var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"lg":"12"}},[_c('v-col',{attrs:{"lg":"12"}},[_c('producer-sun-expert')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }